import React from "react";
import Fadeup from "../fadeup/Fadeup";
import { Link } from "react-router-dom";

const artCardsData = [
  { 
    id: 1,
    title: "The Beauty of Sculpture",
    text: "Explore the intricate details of classical and modern sculptures. From Michelangelo’s David to contemporary abstract forms, sculptures capture movement, emotion, and history in stone, metal, and clay."
  },
  { 
    id: 2,
    title: "Masterpieces in Painting", 
    text: "Dive into the world of famous paintings and their hidden stories. Learn about the techniques of great masters like Van Gogh, Da Vinci, and Monet, and how their art continues to inspire generations."
  },
  { 
    id: 3,
    title: "Digital Art Evolution", 
    text: "Discover how digital tools are reshaping the future of art. From AI-generated masterpieces to digital painting software, technology has transformed how artists create, share, and sell their work."
  },
  { 
    id: 4,
    title: "Street Art & Graffiti",
    text: "Uncover the rebellious and expressive world of street artists. From Banksy’s thought-provoking murals to vibrant graffiti in urban landscapes, street art is a bold and ever-evolving form of cultural expression."
  },
  { 
    id: 5,
    title: "The Renaissance Impact", 
    text: "Learn how Renaissance art shaped modern creativity. This era brought perspective, realism, and human emotion into the spotlight, influencing artists across centuries and laying the foundation for modern artistic expression."
  },
  { 
    id: 6,
    title: "Photography as an Art", 
    text: "See how photography captures emotions, light, and time. From black-and-white portraits to high-speed photography, this medium tells powerful stories through the lens of both amateurs and professionals."
  }
];
function LearnSection() {
  return (
   <section className=" sec_pd">
     <div className=" mt-4">
     <Fadeup delay={0.3}>
     <h3 className="text-center mt-5 mb-4 mx-3 pb-2 text-black fs_40">
     Discover the World of Art
        </h3>
     </Fadeup>
       <Fadeup delay={0.2}>
       <p className="text-center mb-4 mx-3  border-bottom pb-2 text-black">Join our Live Art & Antiques Auction and bid on rare collectibles, exquisite artworks, and historic treasures. <br /> Experience the excitement of live bidding and own a piece of cultural heritage. Don't miss this exclusive opportunity to acquire unique masterpieces!</p>
       </Fadeup>
    
      <div className="row mt-5">
        {artCardsData.map((card) => (
          <div key={card.id} className="col-12 col-md-6 col-lg-4 mb-4">
          <div className="card card_floral floral-border">
            
              <div className="card-body d-flex flex-column justify-content-around gap-3">
                <Fadeup delay={0.3}>
                <h3 className="card-title ">{card.title}</h3>
                </Fadeup>

               <Fadeup delay={0.2}>
               <p className="card-text">{card.text}</p>

                {/* <button className="button_cus text-black w-auto">
                  Explore Now
                </button> */}
                {/* <Link
                    to='/auction'
                    className="btn signup-btn text-white  position-relative overflow-hidden border-0"
                  >
                    <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                      <p className="m-0 text-black fw-bold button_name">
                        Place Bid
                      </p>
                    </div>
                  </Link> */}
               </Fadeup>
              </div>
            </div>

          </div>
        ))}
      </div>
    </div>
   </section>
  );
}

export default LearnSection;
